import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {
  HiOutlineArrowLeft,
  HiOutlineExclamationCircle,
  HiOutlineRefresh,
} from "react-icons/hi";
import { colors, fontFamilyMono, radius, shadows } from "../data/tokens";

// Página de erro do painel — substitui a tela padrão do react-admin
// (título genérico, texto da tradução da biblioteca com erro de
// português e, em desenvolvimento, links de StackOverflow/Enterprise
// que não dizem nada ao operador). Ligada no <Layout error={...}> do
// App.js; o próprio react-admin reseta o erro ao navegar de tela.
export const AppErrorPage = ({ error }: { error?: any }) => {
  const detalhe = String(error?.message || error || "").trim();
  return (
    <Box
      sx={{ display: "flex", justifyContent: "center", padding: "48px 16px" }}
    >
      <Box
        sx={{
          backgroundColor: colors.white,
          borderRadius: `${radius.lg}px`,
          boxShadow: shadows.card,
          maxWidth: 560,
          width: "100%",
          padding: "40px 32px",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            backgroundColor: colors.bgContent,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
          }}
        >
          <HiOutlineExclamationCircle size={36} color={colors.action} />
        </Box>
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 700,
            color: colors.textStrong,
            marginBottom: 1,
          }}
        >
          Não foi possível carregar esta tela
        </Typography>
        <Typography
          sx={{ fontSize: 14, color: colors.textMuted, marginBottom: 3 }}
        >
          Pode ser uma instabilidade momentânea ou falta de conexão com o
          servidor. Tente novamente em instantes — se o problema continuar,
          avise o suporte.
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 1.5,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="contained"
            startIcon={<HiOutlineRefresh size={18} />}
            onClick={() => window.location.reload()}
          >
            Tentar novamente
          </Button>
          <Button
            variant="outlined"
            startIcon={<HiOutlineArrowLeft size={18} />}
            onClick={() => window.history.back()}
          >
            Voltar
          </Button>
        </Box>
        {/* Causa técnica recolhida: não assusta o operador, mas permite
            mandar um print com o motivo real para o suporte */}
        {detalhe && (
          <Box
            component="details"
            sx={{
              marginTop: 3,
              textAlign: "left",
              "& summary": {
                cursor: "pointer",
                fontSize: 12,
                color: colors.textMuted,
              },
            }}
          >
            <Box component="summary">Detalhe técnico (para o suporte)</Box>
            <Typography
              sx={{
                fontSize: 12,
                fontFamily: fontFamilyMono,
                color: colors.textMuted,
                marginTop: 0.5,
                wordBreak: "break-word",
              }}
            >
              {detalhe}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
